import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withTheme } from 'styled-components';
import {
  ACTIVE_ASSAILANT,
  TRAIN_INCIDENT_ALERT_TYPE,
} from '@rsos/constants/alertTypes';
import { getNumUnreadAlertNotifications } from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';
import { filteredAlertsSelector } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import Badge from '../Badge';
import { TotalEvents } from './AlertsBadge.styles';

const AlertsBadge = ({ notifyByAlertType, theme }) => {
  const dispatch = useDispatch();
  const alerts = useSelector(state => filteredAlertsSelector(state.incidents));
  const { numUnreadAlertNotifications } = useSelector(state => state.incidents);
  const numTotalAlerts = Object.keys(alerts).length;
  const bgColor = notifyByAlertType ? theme.colors.background : '';
  const counterColor =
    notifyByAlertType === ACTIVE_ASSAILANT
      ? theme.colors.lightDanger
      : notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE
        ? theme.colors.primaryText
        : '';
  useEffect(() => {
    dispatch(getNumUnreadAlertNotifications());
  }, [alerts, dispatch]);

  return numUnreadAlertNotifications > 0 ? (
    <Badge
      counter={numUnreadAlertNotifications}
      bgColor={bgColor}
      color={counterColor}
    />
  ) : // Since there is no background-color for TotalEvents, the color prop value is reversed.
  numTotalAlerts > 0 ? (
    <TotalEvents color={bgColor}>({numTotalAlerts})</TotalEvents>
  ) : // don't render "(0)" if there are no alerts
  null;
};

export default withTheme(AlertsBadge);
